import { DatePipe } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AcompanhamentoProcessualOperacao } from 'src/app/model/acompanhamento-processual.model';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { STATUS_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { AcompanhamentoProcessualService } from './acompanhamento-processual.service';

@Component({
    templateUrl: './acompanhamento-processual-detalhe.component.html',
    styleUrls: ['./acompanhamento-processual-detalhe.component.scss'],
    standalone: false
})
export class AcompanhamentoProcessualDetalheComponent implements OnInit {

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    public acompanhamento: AcompanhamentoProcessualOperacao;
    private ocorrencias: OcorrenciaValidacaoVO[] = [];
    public acompanhamentoForm: UntypedFormGroup = null;
    public podeVisualizarValidacoes: boolean;
    
    constructor(protected injector: Injector,
        private service: AcompanhamentoProcessualService,
        private permissaoService: PermissaoService,
        private activatedRoute: ActivatedRoute,
        private datePipe: DatePipe,
        private fb: UntypedFormBuilder,
        private router:Router
    ) {
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        // this.config.rotaLista = '/solicitacoes-honra/pesquisa';
    }

    criarFormulario() {
        return this.fb.group({
            cnpjAgenteFinanceiro: null,
            idOperacao: null,
            sistemaCobranca: null,
            idExternoOperacao: null,
            contrato: null,
            tipoCobranca: null,
            dataEnvio: null,
            statusProtocolo: null,
            faseProcessual: null,
            numeroProcesso: null,
            especieAcaoRecurso: null,
            observacoes: null,
            juizo: null,
            comarca: null,
            cobrancaEncerrada: null,
            valorSaldoDevedorTotal: null,
            valorSaldoDevedorDePrincipal: null,
            valorSaldoDeJurosNaNormalidade: null,
            valorSaldoDeEncargosMoratorios: null
        });
    }

    ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp =>{
            if(resp[ROLE_AGENTE_CONSULTA] || resp[ROLE_GESTOR_CONSULTA]){
                this.activatedRoute.params
                .pipe(
                    switchMap((params)=>{
                        const id = params['id'];
                        if(id){
                            return this.service.findById(id);
                        }
                        
                        return of(new AcompanhamentoProcessualOperacao())
                    })
                )
                .subscribe( model =>{
                    this.acompanhamento = model;
                    this.construirFormulario(model)
                    this.acompanhamentoForm.disable();
                });
            }
            else {
                this.voltar();
            }
        })
    }

    voltar() {
        this.router.navigate(['/acompanhamento-processual/pesquisa']);
    }

    construirFormulario(model: AcompanhamentoProcessualOperacao) {
        if (!this.acompanhamentoForm) {
            this.acompanhamentoForm = this.criarFormulario();
        }
        if(model){
            this.acompanhamentoForm.patchValue({
                cnpjAgenteFinanceiro: model?.cnpjAgenteFinanceiro || null,
                idOperacao: model?.idOperacao || null,
                sistemaCobranca: model?.sistemaCobranca || null,
                idExternoOperacao: model?.idOperacaoAgente || null,
                contrato: model?.contratoCobranca || null,
                tipoCobranca: model?.tipoCobranca || null,
                dataEnvio: model?.dataEnvio ? this.datePipe.transform(model.dataEnvio, "dd/MM/yyyy") : null,
                statusProtocolo: model?.statusProtocolo ? STATUS_PROTOCOLO.filter(s => model.statusProtocolo == s.codigo)[0]?.label :null,
                faseProcessual: model?.faseProcessual || null,
                numeroProcesso: model?.numeroProcesso || null,
                especieAcaoRecurso: model?.especieAcaoRecurso || null,
                observacoes: model?.observacoes || null,
                juizo: model?.juizo || null,
                comarca: model?.comarca || null,
                cobrancaEncerrada: model?.cobrancaEncerrada == 'S' ? true : false,
                valorSaldoDevedorTotal: model?.valorSaldoDevedorTotal || null,
                valorSaldoDevedorDePrincipal: model?.valorSaldoDevedorDePrincipal || null,
                valorSaldoDeJurosNaNormalidade: model?.valorSaldoDeJurosNaNormalidade || null,
                valorSaldoDeEncargosMoratorios: model?.valorSaldoDeEncargosMoratorios || null
            });
        }
    }

}